import { NgModule }                            from '@angular/core';
import { ModalBaseScrollableContentComponent } from '@core/modal-base/component/modal-base-scrollable-content/modal-base-scrollable-content.component';
import { SharedModule }                        from '@shared/shared.module';

@NgModule( {
	declarations: [
		ModalBaseScrollableContentComponent
	],
	exports: [
		ModalBaseScrollableContentComponent
	],
	imports: [
		// Shared
		SharedModule
	]
} )
export class ModalBaseScrollableContentModule {}
